import { sha256 } from 'js-sha256'

/**
 * The id hash the server uses in reordering events.
 *
 * `applications_reordered` and `tables_reordered` both send SHA-256 hashes
 * instead of ids, and `tables_reordered` hashes the database id too. The
 * backend says why in `ws/signals.py`: the order goes to everyone in the
 * workspace, and the ids of applications or tables a member cannot open would
 * leak with it. So a client finds itself in the list by hashing its own ids.
 *
 * Matches `generate_hash` on the server and `generateHash` in the Vue app: a
 * SHA-256 of the id rendered as a decimal string.
 */
export function hashId(id: number): string {
  return sha256(String(id))
}
